import {Column} from 'react-table'
import {DownloadRequestItem, DownloadRequestStatus} from '../../core/_models'
import {ActionsCell} from './ActionsCell'

const statusLabel: Record<DownloadRequestStatus, string> = {
  pending: 'Aguardando',
  processing: 'Processando',
  ready: 'Pronto',
  failed: 'Falhou',
  downloaded: 'Baixado',
}

const statusBadge: Record<DownloadRequestStatus, string> = {
  pending: 'badge-light-warning',
  processing: 'badge-light-primary',
  ready: 'badge-light-success',
  failed: 'badge-light-danger',
  downloaded: 'badge-light-info',
}

const reportTypeLabel: Record<string, string> = {
  sales: 'Vendas',
  'sale-items': 'Itens de Venda',
  customers: 'Clientes',
  transfers: 'Transferências',
  recurrence: 'Recorrência',
  salesman: 'Meta de Venda',
  'sales-by-day': 'Vendas por Dia',
  'bonus-sales': 'Vendas Bônus',
  client_analytics: 'Métricas de Clientes',
}

const formatDate = (value: string | null) => {
  if (!value) return '-'
  return new Date(value).toLocaleString('pt-BR')
}

const downloadRequestColumns: ReadonlyArray<Column<DownloadRequestItem>> = [
  {
    Header: 'Tipo',
    id: 'type',
    Cell: ({row}) => <span className='text-dark fw-bold'>{row.original.type === 'kpi' ? 'KPI' : 'Relatório'}</span>,
  },
  {
    Header: 'Relatório',
    id: 'report_type',
    Cell: ({row}) => (
      <span className='text-dark'>
        {reportTypeLabel[row.original.report_type] ?? row.original.report_type}
      </span>
    ),
  },
  {
    Header: 'Status',
    id: 'status',
    Cell: ({row}) => (
      <span className={`badge ${statusBadge[row.original.status]}`}>
        {statusLabel[row.original.status]}
      </span>
    ),
  },
  {
    Header: 'Solicitado em',
    id: 'requested_at',
    Cell: ({row}) => <span>{formatDate(row.original.requested_at)}</span>,
  },
  {
    Header: 'Concluído em',
    id: 'completed_at',
    Cell: ({row}) => <span>{formatDate(row.original.completed_at)}</span>,
  },
  {
    Header: 'Expira em',
    id: 'expires_at',
    Cell: ({row}) => <span>{formatDate(row.original.expires_at)}</span>,
  },
  {
    Header: 'Ações',
    id: 'actions',
    Cell: ({row}) => <ActionsCell row={row.original} />,
  },
]

export {downloadRequestColumns}
